import { render, staticRenderFns } from "./SkillsSelector.vue?vue&type=template&id=68dbf079&scoped=true"
import script from "./SkillsSelector.vue?vue&type=script&lang=ts"
export * from "./SkillsSelector.vue?vue&type=script&lang=ts"
import style0 from "./SkillsSelector.vue?vue&type=style&index=0&id=68dbf079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dbf079",
  null
  
)

export default component.exports